export enum LocalEvents {
  NewUserWorkClocking = 'new-user-work-clocking',
  UpdatedUserWorkClocking = 'updated-user-work-clocking',
}
